<template>
<div class="f-l fdqx-e fdqy-c" style="color: #562409;">
	<el-dropdown class="drop" @command="namecommand" placement="bottom-start" style="margin-right: 10px;margin-left: auto;">
		<span class="el-dropdown-link" style="color: #562409;">
			<i class="el-icon-user-solid fs30"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item icon="el-icon-lock" command="setpwd">修改密码</el-dropdown-item>
			<el-dropdown-item icon="el-icon-switch-button" command="logout">退出登录</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	
	<!-- 校区 -->
	<p class="mr20">{{mysch}}</p>
	
	<!-- 职务 -->
	<el-dropdown class="drop" @command="nowjobchang">
		<span class="el-dropdown-link" style="color: #562409;">
			{{nowjob}}<i class="el-icon-arrow-down el-icon--right"></i>
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item v-for="(item,i) in getuser.job" :key="i" :command="i">{{item.name}}</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<!-- 姓名 -->
	<span class="el-dropdown-link mr20" style="color: #562409;">
		{{getuser.name}}
	</span>
	<el-drawer title="修改密码" :visible.sync="reppwd" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" style="width: 350px;">
			<el-form-item prop="oldpwd" label="原密码">
				<el-input v-model="form.oldpwd" type="password" autocomplete="off" size="medium" placeholder="请输入原密码"></el-input>
			</el-form-item>
			<el-form-item prop="newpwd" label="新密码">
				<el-input v-model="form.newpwd" type="password" autocomplete="off" size="medium" placeholder="请输入新密码"></el-input>
			</el-form-item>
			<el-form-item prop="newpwd2" label="确认密码">
				<el-input v-model="form.newpwd2" type="password" autocomplete="off" size="medium" placeholder="请输入确认密码"></el-input>
			</el-form-item>
				<el-button type="primary" size="medium" style="width: 100px;margin-left: 250px;margin-top: 20px;" @click="submit">提交</el-button>
		</el-form>
	</el-drawer>
</div>
</template>

<script>
import { mapGetters,mapMutations  } from 'vuex'
import aes from '../../../public/aes.js'
export default {
	data() {
		return {
			nowjob:"",
			reppwd:false,
			form:{
				oldpwd:"",
				newpwd:"",
				newpwd2:""
			},
			rules:{
				oldpwd:[{validator:(rule,value,callback)=>{
						callback(this.myfun.pwdistrue(value).msg);
					},trigger:'blur'}],
				newpwd:[{validator:(rule,value,callback)=>{
						if(this.form.newpwd.length<10||this.form.newpwd.length>16){
							callback("请示如10-16位密码")
							return
						}
						if(this.form.oldpwd===this.form.newpwd){
							callback("新密码和旧密码不能相同")
							return
						}
						callback()
					},trigger:'blur'}],
				newpwd2:[{validator:(rule,value,callback)=>{
						if(this.form.newpwd2.length<10||this.form.newpwd2.length>16){
							callback("请示如10-16位密码")
							return
						}
						if(this.form.newpwd!==this.form.newpwd2){
							callback("新密码和确认密码不相同")
						}
						callback()
					},trigger:'blur'}],
			}
		}
	},
	computed:{
		...mapGetters("User",["getuser"]),
		...mapMutations("User",["setPagePowert","setDataPower"]),
		mysch(){
			let str=""
			this.getuser.sch.forEach((e,i)=>{
				if(i===0){
					str+=e.name
					return
				}
				str+="/"+e.name
			})
			return str
		},
	},
	methods:{
		namecommand(data){
			if(data==="logout"){
				this.logout()
				return
			}
			if(data==="setpwd"){
				this.setpwd()
			}
		},
		logout(){
			this.$router.push("/login")
		},
		setpwd(){
			this.reppwd=true
		},
		submit(){
			this.$refs.form.validate((e)=>{
				if(!e){
					return
				}
				this.myfun.Loading()
				const formData = new FormData()
				formData.append("oldpwd",aes.encrypt(this.form.oldpwd))
				formData.append("newpwd",aes.encrypt(this.form.newpwd))
				this.axios.post("data:setpwd",formData).then((e)=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("密码修改成功，请重新登陆")
					this.logout()
				})
			})
		},
		nowjobchang(e){
			let choosejob = this.getuser.job[e]
			if(choosejob.name===this.nowjob){
				this.myfun.messageErr("选择职务与当前职务相同，不可更改")
				return
			}
			this.myfun.Loading()
			const formData = new FormData()
			formData.append("nowjob",choosejob.id)
			this.axios.post("data:repNowJob",formData).then((e)=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.setPagePowert(e.pagePower)
				this.setDataPower(e.dataPower)
			})
		}
	},
	created() {
		this.nowjob = this.getuser.job[0].name
		aes.setkey(sessionStorage.getItem("key"))
	}
}
</script>

<style scoped>
.drop{
	margin-right: 20px;
	font-size: 16px;
	text-align: center;
}
</style>
